<template>
	<v-container class="d-flex flex-column justify-end alert-message-center-container pa-0"
		:style="{top: headerHeight + 5 + 'px'}">
		<transition-group
			name="message-fade"
			tag="div"
			appear
		>
			<div
				v-for="message in messages"
				:key="message.uuid"
				class="alert-message-center-inner-container py-1 pl-4 pr-8 mx-1 mb-1"
				:data-uuid="message.uuid"
				@click="sendAction(message)"
				@mouseenter="hoveredMessageId = message.uuid"
				@mouseleave="hoveredMessageId = null"
			>
				<v-icon class="mr-4" :color="message.color" large>{{message.icon}}</v-icon>
				<div>
					<p class="caption mb-0 text-primary font-weight-bold">{{message.title}}</p>
					<p class="mb-0 text--secondary caption">{{message.message}}</p>
				</div>
				<v-icon 
					v-show="hoveredMessageId === message.uuid"
					class="close-icon" 
					color="#524D4D" 
					small 
					@click.stop="closeMessage(message.uuid)"
				>
					mdi-close-circle
				</v-icon>
			</div>
		</transition-group>
	</v-container>
</template>

<script>
export default {
	name: 'MessageCenter',
	components: { },
	filters: {
	},
	data: () => ({
		timers: {},
    entering: false,
    enterDelay: 250,
    lastMessageCount: 0,
    hoveredMessageId: null
	}),
	computed: {
		headerHeight() {
			return this.$store.state.general.headerHeight
		},
		messages() {
			return this.$store.state.general.messagesToMessageCenter
		},
		queue() {
			return this.$store.state.general.messagesQueueToMessageCenter
		}
	},
  watch: {
		messages: {
			immediate: true,
			handler(newMessages) {
				newMessages.forEach(m => this.startTimer(m))
				if (newMessages.length < this.lastMessageCount) {
					this.tryFillSlots()
				}

				this.lastMessageCount = newMessages.length
			}
		},
		queue() {
			this.tryFillSlots()
		}
  },
	mounted(){
	},
  beforeDestroy() {
    Object.values(this.timers).forEach(clearTimeout)
  },
	methods: {
		closeMessage(uuid) {
			if (this.timers[uuid]) {
				clearTimeout(this.timers[uuid])
				delete this.timers[uuid]
			}

			this.$store.commit('general/removeMessagesToMessageCenter', uuid)
		},
		tryFillSlots() {
			if (this.entering) return
			if (this.messages.length >= 2) return
			if (!this.queue.length) return

			this.entering = true

			setTimeout(() => {
				const next = this.queue[0]
				if (!next) {
					this.entering = false
					return
				}

				this.$store.commit('general/shiftMessagesQueueToMessageCenter')
				this.$store.commit('general/setMessagesToMessageCenter', next)

				this.entering = false
				this.tryFillSlots()
			}, this.enterDelay)
		},
		startTimer(message) {
			if (this.timers[message.uuid]) return

			this.timers[message.uuid] = setTimeout(() => {
				this.closeMessage(message.uuid)
			}, message.close || 4000)
		},
    onAfterLeave() {
      if (this.pendingLeaves > 0) {
        this.pendingLeaves--
        this.$store.dispatch('general/fillNextMessage')
      }
    },
    getDelay() {
      return 0
    },
		sendAction(message){
			console.log('message: ', message)
		}
	}
};
</script>

<style scoped>
	.text-primary{color: #524D4D;}
	.alert-message-center-container{
		position: fixed;
		
		right: 10px;
		max-width: 400px;
		z-index: 9999;
	}
	.alert-message-center-inner-container{
		position: relative;
		background-color: white;
		border-radius: 10px;
		border: 1px solid #959595;
		display: flex;
	}
	.clickable{
		cursor: pointer;
	}
	.close-icon{
		position: absolute;
		top: 5px;
		right: 10px;
		cursor: pointer;
		transition: opacity 0.2s ease;
	}
	.close-icon:hover{
		opacity: 0.7;
	}
	.message-fade-enter-active {
		animation: toast-in-right 0.35s ease forwards;
	}
	.message-fade-leave-active {
		animation: toast-out 0.25s ease forwards;
	}

	@keyframes toast-in-right {
		from {
			opacity: 0;
			transform: translateX(40px);
		}
		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes toast-out {
		from {
			opacity: 1;
			transform: translateY(0);
		}
		to {
			opacity: 0;
			transform: translateY(12px);
		}
	}
</style>
